// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-59d4630e] .el-drawer__header > :first-child {\n  font-size: 16px;\n  color: #000;\n}\n.container[data-v-59d4630e] {\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n}\n.footer[data-v-59d4630e] {\n  margin-top: 30px;\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
